export type Account = {
  id: string
  organizations: Record<string, AccountOrganization>
}

export enum Theme {
  LIGHT = 'light',
  DARK = 'dark',
}

export enum OnboardingStatus {
  NOT_STARTED = 'not_started', // Not entered org name
  IN_PROGRESS = 'in_progress', // Entered org name
  SKIPPED = 'skipped', // Entered org name but skipped connected account creation
  COMPLETED = 'completed', // Created connected account
}

export enum AccountPreferenceKeys {
  ACTIVE_CONNECTED_ACCOUNT_ID = 'activeConnectedAccountId',
  ACTIVE_ORGANIZATION_ID = 'activeOrganizationId',
  ONBOARDING_STATUS = 'onboardingStatus',
  THEME = 'theme',
}

export type AccountPreferences = {
  [AccountPreferenceKeys.ACTIVE_CONNECTED_ACCOUNT_ID]?: string
  [AccountPreferenceKeys.ACTIVE_ORGANIZATION_ID]?: string
  [AccountPreferenceKeys.ONBOARDING_STATUS]?: string
  [AccountPreferenceKeys.THEME]?: string
}

export type Me = Account & {
  organizations: OrganizationsDetail
  preferences: AccountPreferences | null
}

export type AccountOrganization = {
  id: string
  roles: Role[]
}

export type OrganizationsDetail = Record<string, OrganizationDetail>

export type OrganizationDetail = AccountOrganization & {
  name: string
  description: string
}

export type Identity = {
  accountId: string
  firstName: string
  lastName: string
  email: string
  lastSignedIn?: string
}

/**
 * The roles are ordered from the highest to the lowest.
 * If you have to enter a new role, add it in the correct position considering the order dictates the hierarchy.
 */
export enum Role {
  OWNER = 'owner',
  ADMIN = 'admin',
  APPROVER = 'approver',
  SPENDER = 'spender',
  VIEWER = 'viewer',
}

export type Organization = {
  id: string
  name: string
  description: string
}

export type Invite = {
  id: string
  email: string
  status: InviteStatus
  roles: Role[]
  createdAt: string
  invitedBy: string
  organization_id: string
  awxConnectedAccountId: string | null
}

export enum InviteStatus {
  SENDING = 'sending',
  SENT = 'sent',
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  EXPIRED = 'expired',
  SIGNING_UP = 'signing_up',
}

export enum InviteResult {
  EXPIRED = 'expired',
  NOT_PENDING = 'not_pending',
  NOT_FOUND = 'not_found',
  ACCEPTED = 'accepted',
  ALREADY_ACCEPTED = 'already_accepted',
}
